import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Keys Requests Status
export const statusList = (params = '') => Http.get(`/key-status-request${serialize(params)}`)
export const statusCreate = (params = '') => Http.post('/key-status-request', params)
export const statusByID = (params = '') => Http.get(`/key-status-request/${params}`)
export const statusUpdate = (params = '') => Http.put(`/key-status-request/${params.id}`, params)
export const statusDestroy = (params = '') => Http.delete(`/key-status-request/${params.id}`)

//LIST OF ALL Keys Requests
export const requestsList = (params = '') => Http.get(`/key-requests${serialize(params)}`)
export const requestCreate = (params = '') => Http.post('/key-requests', params)
export const requestByID = (params = '') => Http.get(`/key-requests/${params}`)
export const requestUpdate = (params = '') => Http.put(`/key-requests/${params.id}`, params)
export const requestDestroy = (params = '') => Http.delete(`/key-requests/${params.id}`)
